document.addEventListener('DOMContentLoaded', function() {
  // Select all check-in components in the page
  const checkInComponents = document.querySelectorAll('.c-check-in');

  checkInComponents.forEach(component => {
    // Find buttons and details div within this specific component
    const openButton = component.querySelector('.js-btn-checkin-panel-open');
    const closeButton = component.querySelector('.js-btn-checkin-panel-close');
    const detailsDiv = component.querySelector('.js-checkin-panel');

    if (openButton && closeButton && detailsDiv) {
      // Handle click on open button
      openButton.addEventListener('click', function() {
        detailsDiv.style.display = 'block';
        openButton.disabled = true;
        openButton.classList.add('c-button--disabled');
      });

      // Handle click on close button
      closeButton.addEventListener('click', function() {
        detailsDiv.style.display = 'none';
        openButton.disabled = false;
        openButton.classList.remove('c-button--disabled');
      });
    }
  });
}); 